import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

export const multiNodalReportReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'MULTI_NODAL_REPORT_LOADED':
      return state.set('list', fromJS(action.data));
    case 'MULTI_NODAL_REPORT_SELECT':
      return state.set('selected', fromJS(action.selected));
    case 'MULTI_NODAL_REPORT_CLEAR':
      return new Map();
    default:
      return state;
  }
};

export const generateReport = (dispatch, ids) => {
  dispatch({ type: 'MULTI_NODAL_REPORT_LOADING' });
  markStoreLoading(dispatch, 'user_performance');
  return RestAPI.get(`/deals/purchase/api/multi?ids=${ids}`)
    .then(
      data => {
        markStoreLoaded(dispatch, 'user_performance');
        dispatch({ type: 'MULTI_NODAL_REPORT_LOADED', data });
      }
    );
};

export const clearReport = dispatch => dispatch({ type: 'MULTI_NODAL_REPORT_CLEAR' });

export const handleSelect =
  (dispatch, selected) => dispatch({ type: 'MULTI_NODAL_REPORT_SELECT', selected });
